import React, {
  FormEvent,
  MouseEvent,
  FunctionComponent,
  CSSProperties,
} from "react";
import Icon from "../Icon";
import { StyledButton } from "./styled";

type Props = {
  secondary?: boolean;
  children: string | string[] | React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  active?: boolean;
  style?: CSSProperties;
  type?: "button" | "submit";
  id?: string;
  light?: boolean;
  name?: string;
  value?: string;
  onClick?: (event?: Event | FormEvent | MouseEvent) => void;
};

const Button: FunctionComponent<Props> = ({
  secondary,
  onClick,
  children,
  disabled,
  loading,
  style,
  type,
  active,
  id,
  light,
  name,
  value,
}: Props) => {
  return (
    <StyledButton
      id={id}
      active={active}
      secondary={secondary}
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      style={style}
      light={light}
      name={name}
      value={value}
    >
      {loading && (
        <Icon
          style={{ position: "absolute", right: "10px" }}
          name="loading"
          size={3}
        />
      )}
      {children}
    </StyledButton>
  );
};

Button.defaultProps = {
  style: null,
  secondary: false,
  disabled: false,
  loading: false,
  type: null,
  active: false,
  light: false,
  id: "button",
  name: null,
  value: null,
  onClick: () => {},
};

export default Button;
